import {Component} from 'react';

import DialogService from '-/services/DialogService';
import NavigationService from '-/services/NavigationService';
import Dialog from './Dialog';

const TWO_MINUTES = 1000 * 60 * 2;

class InactivityAlertDialog extends Component {
    componentDidMount() {
        this.token = setTimeout(() => {
            DialogService.show(false);
            NavigationService.startOver();
        }, TWO_MINUTES);
    }

    handleDialogClose = () => {
        DialogService.show(false);
        clearTimeout(this.token);
    };

    render() {
        return (
            <Dialog>
                <p className="info">
                    <strong>Your session will end in 2 minutes due to inactivity</strong>
                </p>
                <p className="info">As a security precaution, if there is no additional activity in your application, the session will end and you will be brought to the home page.</p>
                <p className="info">If you are still working in your application, choose Ok to continue.</p>
                <section className="steps-buttons">
                    <div className="row">
                        <div className="cell">
                            <a onClick={this.handleDialogClose}>Ok</a>
                        </div>
                    </div>
                </section>
            </Dialog>
        );
    }
}

export default InactivityAlertDialog;
